export const CHARACTERIZATION_GREEN = 0;
export const CHARACTERIZATION_YELLOW = 1;
export const CHARACTERIZATION_RED = 2;
